import React, { useState, useEffect } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import HondaLoader from '../../components/common/HondaLoader';
import { sanitizeInput, formatCuit } from '../../utils/inputValidation';
import { getScoringListing } from '../../services/userservice';
import Swal from 'sweetalert2';
const RevisionDocumentacion = ({ user, onLogout, onNavigate }) => {
  
  const [searchTerm, setSearchTerm] = useState('');
  const [documentos, setDocumentos] = useState([]);
  const [loading, setLoading] = useState(true);
  // Función para formatear fecha de yyyy-mm-dd a dd-mm-yyyy
  const formatearFecha = (fecha) => {
    if (!fecha || fecha === 'N/A') {
      return 'N/A';
    }
    try {
      // Si ya está en formato dd-mm-yyyy o dd/mm/yyyy, convertir
      if (fecha.includes('/')) {
        const partes = fecha.split('/');
        if (partes.length === 3) {
          const [dia, mes, anio] = partes;
          return `${dia}-${mes}-${anio}`;
        }
      }
      // Si está en formato yyyy-mm-dd, convertir a dd-mm-yyyy
      if (fecha.includes('-')) {
        const partes = fecha.split('-');
        if (partes.length === 3) {
          // Verificar si es yyyy-mm-dd o dd-mm-yyyy
          if (partes[0].length === 4) {
            // Es yyyy-mm-dd
            const [anio, mes, dia] = partes;
            return `${dia}-${mes}-${anio}`;
          } else {
            // Ya está en dd-mm-yyyy
            return fecha;
          }
        }
      }
      return fecha;
    } catch (error) {
      console.error('Error formateando fecha:', error);
      return fecha;
    }
  };
  // Cargar casos EN REVISION desde el backend al montar el componente
  useEffect(() => {

      loadData();
   
  }, []);

  const loadData = async () => {
      try {
        setLoading(true);

        let enRevision;

        //COMPLIANCE
        console.log('User group ID:', user.username, user.group_ID);
        if(user.group_ID){
          if(user.group_ID === 4){ 
            
            //Obtener casos EN REVISION ESPECIAL
            enRevision = await getScoringListing('EN REVISION ESPECIAL', 0);

          }  else {

            //Obtener casos EN REVISION
            enRevision = await getScoringListing('EN REVISION', 0);

          }
        }
        
        // Mapear al formato esperado
        const mapearCasos = (casos) => casos.map((item, index) => {
          const fechaAceptacion = item.acceptDate || item.aceptacion || 'N/A';
          return {
            id: item.id || index + 1,
            grupo: item.group || item.grupo || 'N/A',
            orden: item.order || item.orden || 'N/A',
            titular: item.mainName || item.titularName || item.titular || 'N/A',
            cuil: item.cuil || item.cuit || 'N/A',
            aceptacion: formatearFecha(fechaAceptacion),
            porcentajeDeuda: item.debtPercent || item.porcentajeDeuda || '0',
            concesionario: item.sellerHouse?.ceName || item.concesionario || 'N/A',
            fechaEstado: item.statusDate || item.fechaEstado || 'N/A',
            estado: 'en revision'
          };
        });
        const casosEnRevision = mapearCasos(enRevision);
        setDocumentos(casosEnRevision);
      } catch (err) {
        console.error('Error cargando casos EN REVISION:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error al cargar datos',
          text: 'No se pudieron cargar los casos en revisión. Por favor intente nuevamente.',
          confirmButtonColor: '#ef4444',
        });
      } finally {
        setLoading(false);
      }
    };

  const handleRevisar = (documento) => {
    // Preparar datos para EvaluarExpediente
    const casoData = {
      grupo: documento.grupo,
      orden: documento.orden,
      titular: documento.titular,
      cuil: documento.cuil,
      aceptacion: documento.aceptacion,
      concesionario: documento.concesionario,
      porcentajeDeuda: documento.porcentajeDeuda,
      estado: documento.estado,
      fromRevision: true, // Indica que viene de revisión de casos
      idScoring: documento.id
    };
    // Guardar en localStorage para que EvaluarExpediente lo recupere
    localStorage.setItem('casoData', JSON.stringify(casoData));
    // Navegar a la vista EvaluarExpediente
    onNavigate('evaluarExpediente', {
      grupo: documento.grupo,
      orden: documento.orden,
      estado: documento.estado
    });
  };
  const filteredDocumentos = documentos.filter(doc => {
    const matchesSearch = doc.titular.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          doc.grupo.includes(searchTerm) ||
                          doc.orden.includes(searchTerm) ||
                          doc.cuil.includes(searchTerm);
    return matchesSearch;
  });
  return (
    <MainLayout user={user} onLogout={onLogout} onNavigate={onNavigate}>
      <div className="max-w-full mx-auto px-3 py-4">
        {/* Título */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-1.5 h-8 gradient-red rounded-full shadow-glow-red"></div>
            <h2 className="text-2xl font-bold text-gradient">
              Análisis de Casos <span style={{ fontSize: '16px' }}>{user.group_ID === 4 ? '| Honda Compliance' : ''}</span>
            </h2>
          </div>
          <p className="text-gray-500 text-sm ml-5">Casos en estado de revisión pendientes de análisis <b>{user.group_ID === 4 ? 'Compliance' : ''}</b></p>
        </div>
        {/* Búsqueda */}
        <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-medium text-gray-500 mb-1">Buscar</label>
              <input
                type="text"
                placeholder="Buscar por titular, grupo, orden o DNI..."
                value={searchTerm}
                onChange={(e) => {
                  const sanitized = sanitizeInput(e.target.value);
                  setSearchTerm(sanitized);
                }}
                className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-md text-gray-800 text-sm focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
              />
            </div>
          </div>
        </div>
        {/* Tabla de documentos */}
        {loading ? (
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-12">
            <HondaLoader 
              message="Cargando casos en revisión..." 
              variant="inline"
              size="large"
              subtitle="Obteniendo casos para analizar"
            />
          </div>
        ) : (
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gradient-to-r from-red-600 to-red-700">
                <tr>
                  <th className="px-4 py-4 text-left text-xs font-bold text-white uppercase tracking-wider">Grupo</th>
                  <th className="px-4 py-4 text-left text-xs font-bold text-white uppercase tracking-wider">Orden</th>
                  <th className="px-4 py-4 text-left text-xs font-bold text-white uppercase tracking-wider">Titular</th>
                  <th className="px-4 py-4 text-left text-xs font-bold text-white uppercase tracking-wider">DNI</th>
                  <th className="px-4 py-4 text-left text-xs font-bold text-white uppercase tracking-wider">Aceptación</th>
                  <th className="px-4 py-4 text-left text-xs font-bold text-white uppercase tracking-wider">Deuda</th>
                  <th className="px-4 py-4 text-left text-xs font-bold text-white uppercase tracking-wider">Concesionario</th>
                  <th className="px-4 py-4 text-center text-xs font-bold text-white uppercase tracking-wider">Acciones</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredDocumentos.map((doc) => (
                  <tr key={doc.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-3 text-sm text-gray-900">{doc.grupo}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{doc.orden}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{doc.titular}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{formatCuit(doc.cuil)}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{doc.aceptacion}</td>
                    <td className="px-4 py-3 text-sm">
                      <span className={`inline-flex px-2 py-1 rounded-full text-xs ${
                        parseFloat(doc.porcentajeDeuda) > 66 ? 'bg-red-100 text-red-700' :
                        parseFloat(doc.porcentajeDeuda) > 33 ? 'bg-yellow-100 text-yellow-700' :
                        'bg-green-100 text-green-700'
                      }`}>
                        {doc.porcentajeDeuda}%
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900 max-w-xs truncate" title={doc.concesionario}>
                      {doc.concesionario}
                    </td>
                    <td className="px-4 py-3 text-center">
                      <button
                        onClick={() => handleRevisar(doc)}
                        className="inline-flex items-center justify-center w-8 h-8 rounded-full text-green-600 hover:bg-green-600 hover:text-white transition-colors"
                        title="Revisar caso"
                      >
                        <span className="material-icons text-xl">arrow_forward</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filteredDocumentos.length === 0 && (
            <div className="text-center py-12">
              <span className="material-icons text-5xl text-gray-300 mb-3">description</span>
              <p className="text-gray-400">No hay casos en revisión</p>
              <p className="text-gray-300 text-sm mt-1">
                Los casos aparecerán aquí cuando estén en estado "EN REVISION"
              </p>
            </div>
          )}
        </div>
        )}       
      </div>
    </MainLayout>
  );
};
export default RevisionDocumentacion;

